module.exports = __webpack_public_path__ + "static/img/Mitch-Duncan.1ad5ac1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mitch-Duncan.jpg
// module id = CrEH
// module chunks = 0